import React from "react";
import cn from "classnames";
import styles from "./KpiTile.module.sass";

/**
 * Métrica pinchable con delta frente al periodo anterior y sparkline. Sale de
 * Subscriptions (06 §4) para reutilizarla en Referidos y en el panel del socio.
 *
 * `delta = { now, before, fmt?: "pct"|"eur"|"pp", invert? }`: `invert` para
 * métricas en las que bajar es bueno (bajas, reembolsos…).
 */
const fmtNumber = (v, locale) => (v == null ? "—" : Number(v).toLocaleString(locale));

export const DeltaChip = ({ delta, formatMoney, locale = "es-ES" }) => {
  const d = delta;
  if (!d || d.before == null) return null;
  const diff = d.now - d.before;
  if (diff === 0) return <span className={cn(styles.kpiDelta, styles.flat)}>=</span>;
  const up = diff > 0;
  const good = d.invert ? !up : up;
  const n = (v) => fmtNumber(v, locale);
  let label;
  if (d.fmt === "pct") label = d.before ? `${up ? "+" : ""}${Math.round((diff / Math.abs(d.before)) * 100)}%` : `${up ? "+" : ""}${n(diff)}`;
  else if (d.fmt === "eur") label = `${up ? "+" : "−"}${formatMoney ? formatMoney(Math.abs(diff)) : n(Math.abs(diff))}`;
  else if (d.fmt === "pp") label = `${up ? "+" : ""}${n(diff)} pp`;
  else label = `${up ? "+" : ""}${n(diff)}`;
  return <span className={cn(styles.kpiDelta, good ? styles.up : styles.down)}>{up ? "▲" : "▼"} {label}</span>;
};

export const Spark = ({ values, color }) => {
  if (!values || values.length < 2) return null;
  const max = Math.max(...values), min = Math.min(...values);
  const span = max - min || 1;
  const pts = values.map((v, i) => `${(i / (values.length - 1)) * 100},${26 - ((v - min) / span) * 22 - 2}`).join(" ");
  return (
    <svg className={styles.spark} viewBox="0 0 100 26" preserveAspectRatio="none">
      <polyline points={pts} fill="none" stroke={color} strokeWidth="2" vectorEffect="non-scaling-stroke" strokeLinejoin="round" />
    </svg>
  );
};

export const KpiGrid = ({ children }) => <div className={styles.kpiGrid}>{children}</div>;

const KpiTile = ({ label, value, sub, delta, spark, color, active, onClick, formatMoney, locale }) => (
  <button type="button" className={cn(styles.kpiTile, { [styles.kpiOn]: active })} onClick={onClick}>
    <div className={styles.kpiLabel}>{label}</div>
    <div className={styles.kpiValue}>{value}</div>
    <div className={styles.kpiFoot}>
      <DeltaChip delta={delta} formatMoney={formatMoney} locale={locale} />
      <span className={styles.kpiSub}>{sub}</span>
    </div>
    <Spark values={spark} color={color} />
  </button>
);

export default KpiTile;
